import React, { useState } from "react";
import { FaSyncAlt, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import axios from "axios";
import s from "../styles/UpdateXmlButton.module.css";

const UpdateXmlButton = ({ projectId }) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("idle"); // idle | success | error
  const [errorMessage, setErrorMessage] = useState("");

  const handleUpdate = async () => {
    setLoading(true);
    setStatus("idle");
    setErrorMessage("");

    try {
      const res = await axios.post("/update_google_to_xml", {
        project_id: projectId,
      });

      const result = res.data?.result;

      if (result === "success") {
        setStatus("success");
      } else {
        setStatus("error");
        setErrorMessage(result || "Неизвестная ошибка");
      }

    } catch (err) {
      setStatus("error");
      setErrorMessage("Ошибка сети или сервера");
    } finally {
      setLoading(false);
      setTimeout(() => {
        setStatus("idle");
        setErrorMessage("");
      }, 3000);
    }
  };

  const renderIcon = () => {
    if (status === "success") return <FaCheckCircle className={s.icon_success} />;
    if (status === "error") return (
      <FaTimesCircle
        className={s.icon_error}
        title={errorMessage}
      />
    );
    return <FaSyncAlt className={`${s.icon} ${loading ? s.spin : ""}`} />;
  };

  return (
    <div
      className={s.icon_wrapper}
      onClick={!loading ? handleUpdate : null}
      title="Обновить XML"
    >
      {renderIcon()}
    </div>
  );
};

export default UpdateXmlButton;
